import { EventEmitter, Injectable, Output } from '@angular/core';
import { CallClient, CallAgent, DeviceManager, Call, Features, CaptionsCallFeature, PropertyChangedEvent } from '@azure/communication-calling';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { CommunicationIdentityClient } from '@azure/communication-identity';

const voiceCallApiEndPoint: string = ''; //environment.voiceApi;
const voiceCallerId: string = ''; //environment.voiceCallerId

@Injectable({
  providedIn: 'root'
})

export class AcsService {
  private callClient!: CallClient;
  private call: Call | undefined;
  private callAgent!: CallAgent | undefined;
  private deviceManager!: DeviceManager;

  public captions: CaptionsCallFeature;
  public printCallMessage: string = "";
  public serviceCallInProgress: boolean = false;
  public serviceAcsServiceAvailable: boolean = false;

  @Output() callConnected: EventEmitter<any> = new EventEmitter<any>();
  @Output() callDisconnected: EventEmitter<any> = new EventEmitter<any>();
  @Output() callringing: EventEmitter<any> = new EventEmitter<any>();

  async createACSToken() {
    if (!voiceCallApiEndPoint) return { userId: '', token: '' };
    const tokenClient = new CommunicationIdentityClient(voiceCallApiEndPoint);
    const user = await tokenClient.createUser();
    const userToken = await tokenClient.getToken(user, ["voip"]);
    return { userId: user.communicationUserId, ...userToken };
  }

  //Send Messages
  async loadPrintCallMessage(callMessage: string) {
    console.log(callMessage);
    this.printCallMessage = callMessage;
  }

  //Dynaic Azure User Token
  async initializeAcsService() {
    try {
      await this.loadPrintCallMessage('Loading Dialer...');
      let acsObject = await this.createACSToken();

      this.callClient = new CallClient();
      const tokenCredential = new AzureCommunicationTokenCredential((await acsObject).token);
      this.callAgent = await this.callClient.createCallAgent(tokenCredential);
      this.deviceManager = await this.callClient.getDeviceManager();
      await this.deviceManager.askDevicePermission({ audio: true, video: false });
      await this.autoSelectAudioDevice();

      this.serviceAcsServiceAvailable = true;
      await this.loadPrintCallMessage('Dialer is ready.');

    } catch (error) {
      await this.loadPrintCallMessage('ERROR:: initializeAcsService ->> ' + error);
    }
  }

  //Select Audio Device
  async autoSelectAudioDevice() {
    try {
      const speakers = await this.deviceManager.getSpeakers();
      if (speakers.length > 0) {
        await this.deviceManager.selectSpeaker(speakers[0]);
        // console.log('Speaker selected:', speakers[0].name);
        await this.loadPrintCallMessage('Speaker selected - ' + + speakers[0].name);

      } else {
        console.log('No speakers found');
      }
    } catch (e) {
      await this.loadPrintCallMessage('ERROR::autoSelectAudioDevice ->> ' + e);
    }
  }

  //Call - Start
  async startCall(phoneNumber: string) {
    try {
      if (!this.callAgent) {
        await this.loadPrintCallMessage('ERROR::startCall ->> Call agent is not initialized.');
        return;
      }
      this.serviceCallInProgress = true;

      const callOptions = {
        audioOptions: {
          muted: false,
        },
        alternateCallerId: {
          phoneNumber: voiceCallerId
        }
      };   //phoneNumber: "+18337939104"

      ////Making Call Now
      this.call = this.callAgent.startCall(
        [{ phoneNumber: phoneNumber }], callOptions
      );

      //Managing Call Statuses
      this.call.on('stateChanged', async () => {
        if (this.call.state == undefined){
          return;          
        }
        
        await this.loadPrintCallMessage(this.call.state);
        if (this.call.state === 'Ringing') {
          await this.loadPrintCallMessage('Ringing...');
          this.callringing.emit();
        }
        else if (this.call.state === 'Connected') {
          this.serviceCallInProgress = true;
          await this.loadPrintCallMessage('Call is connected...');
          this.captions = this.call.feature(Features.Captions);
          this.callConnected.emit();
        }
        else if (this.call.state === 'Disconnected') {
          this.serviceCallInProgress = false;
          await this.loadPrintCallMessage('Call Disconnected Successfully.');
          this.endCall();
        }
      });

      this.call.on('isMutedChanged', async () => {
        await this.loadPrintCallMessage('Muted:' + this.call.isMuted);
      });

      this.call.on('remoteParticipantsUpdated', async (event) => {
        //await this.loadPrintCallMessage('Remote Participants:' + event);
      });
    }
    catch (e) {
      this.serviceCallInProgress = false;
      await this.loadPrintCallMessage('ERROR::Start Call ->> ' + e);
    }
  }

  //Call - End
  async endCall() {
    try {
      if (!this.callAgent) {
        await this.loadPrintCallMessage('Call agent is not initialized.');
        return;
      }
      if (this.call) {
        this.call.hangUp({
          forEveryone: true
        });
        this.call = undefined;
        this.callDisconnected.emit();
        // if (this.call.state === 'Connected') {
        //   this.serviceCallInProgress = false;
        //   this.call.hangUp({ 
        //     forEveryone: true 
        //   });
        //   this.call = undefined;
        //   await this.loadPrintCallMessage('Call Disconnected Successfully.');
        //   this.callDisconnected.emit();
        // }
      }
    } catch (e) {
      this.serviceCallInProgress = false;
      await this.loadPrintCallMessage('ERROR::endCall ->> ' + e);
    }
  }
}
